import { render, staticRenderFns } from "./StopwatchViewRoot.vue?vue&type=template&id=4a456b17&scoped=true&"
import script from "./StopwatchViewRoot.vue?vue&type=script&lang=js&"
export * from "./StopwatchViewRoot.vue?vue&type=script&lang=js&"
import style0 from "./StopwatchViewRoot.vue?vue&type=style&index=0&id=4a456b17&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a456b17",
  null
  
)

export default component.exports